<template>
    <div style="position:relative" class="mt-3">
      <v-card-title>
      <v-btn
        absolute
        dark
        fab
        top
        right
        color="primary"
        @click.native.stop="onOpenDialog('dialog')">
        <v-icon>add</v-icon>
      </v-btn>
      </v-card-title>
      <m-todo-add-form :form="form" :dialog="dialog" @save="addTodo" @close="onClose"></m-todo-add-form>
      <m-todo-edit-form :form="form" :dialog="dialog_edit" @save="updateTodo" @close="onClose"></m-todo-edit-form>

      <kanban-board :stages="stages" :blocks="tasks" @update-block="updateBlock">
        <div v-for="stage in stages" :class="stage" :slot="stage" :key="stage">
          <h2>{{ stage }}</h2>
        </div>
        <div v-for="block in tasks" :slot="block.id" :key="block.id">
          <div class="date">
            <strong>Date:</strong> {{ block.data.date }} {{ block.data.time }}
          </div>
          <div class="body-2 mt-2">
            {{ block.data.title }}
          </div>
          <div class="comment">
            {{ block.data.comment }}
          </div>
          <div class="controls">
          <div class="controls-holder">
            <div class="item" @click="editTodo(block)"><v-icon color="primary">edit</v-icon></div>
            <div class="item" @click="removeTodo(block)"><v-icon color="primary">delete</v-icon></div>
          </div>
          </div>
        </div>
      </kanban-board>
    </div>
</template>

<script>
// import moment from 'moment';
import { mapGetters } from 'vuex'
import moment from 'moment';
import Auth from '@/core/auth';
import { database } from '@/services/firebase';
import TodoAddForm from '@/components/todo/add.vue'
import TodoEditForm from '@/components/todo/edit.vue'
export default {
  name: 'tasks',
  props: [],
  components: {
    'm-todo-add-form': TodoAddForm,
    'm-todo-edit-form': TodoEditForm
  },
  computed: {
    ...mapGetters(['tasks']),
    user: Auth.getUser
  },
  data () {
    return {
      newTodo: {},
      menu_date: false,
      dateFormatted: null,
      dialog: false,
      dialog_edit: false,
      form: {},
      tasksRef: null,
      newTodoText: '',
      stages: ['on-hold', 'in-progress', 'done']
    };
  },
  methods: {
    reset () {
      this.form = {}
    },
    onOpenDialog (dialog) {
      this[dialog] = true;
      console.log('open');
    },
    formatDate (date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    changeDate (e) {
      this.menu_date = false;
    },
    removeTodo (todo) {
      this.tasksRef.child(todo['.key']).remove()
    },
    editTodo (todo) {
      this.form = todo.data;
      this.dialog_edit = true;
      console.log('todos: ', todo);
      console.log('edit todo:', todo['.key']);
    },
    updateTodoText (todo, val) {
      this.tasksRef.child(todo['.key']).child('text').set(val)
    },
    addTodo () {
      console.log('add');
      if (this.form.title) {
        this.dialog = false;
        this.tasksRef.push({
          status: 'on-hold',
          data: this.form,
          user: [this.user.id]
        }).then((data) => {
          console.log('firebase dat:', data);
          this.tasksRef.child(data.key).update({id: data.key})
          this.tasksRef.child(data.key).child('data').update({id: data.key})
          this.reset();
        });
      }
    },
    updateTodo () {
      console.log('add');
      if (this.form.title) {
        this.dialog_edit = false;
        this.tasksRef.child(this.form.id).update({
          data: this.form
        }).then((data) => {
          console.log('firebase updated:', data);
        });
      }
    },
    onClose () {
      this.dialog = false;
      this.dialog_edit = false;
    },
    updateTodoStatus (id, val) {
      this.tasksRef.child(id).child('status').set(val)
    },
    updateBlock (id, status) {
      // var todo = this.todos.find(b => b.id === Number(id));
      console.log(id);
      this.updateTodoStatus(id, status)
    }
  },
  created () {
    // this.$store.dispatch('setTasksRef',  {ref: tasksRef, limit: 5} )
    this.tasksRef = database.ref('tasks');
    this.$store.dispatch('setTasksRef', { ref: this.tasksRef, limit: 25 });
    console.log(this.tasks);
  },
  watch: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
$ease-out: all .3s cubic-bezier(0.23, 1, 0.32, 1);

ul.drag-list, ul.drag-inner-list {
    list-style-type: none;
    margin: 0;
    padding: 0;
}

.drag-container {
    // max-width: 1000px;
    margin: 10px auto;
}

.drag-list {
    display: flex;
    align-items: flex-start;

    @media (max-width: 690px) {
        display: block;
    }
}

.drag-column {
    flex: 1;
    margin: 0 10px;
    position: relative;
    background: rgba(rgb(211, 209, 209), 0.2);
    overflow: hidden;
    border: solid 1px rgba(rgb(211, 209, 209), 0.8);

    @media (max-width: 690px) {
      margin-bottom: 30px;
    }

    h2 {
        font-size: 0.8rem;
        margin: 0;
        text-transform: uppercase;
        font-weight: 600;
    }
}

.drag-column-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
}

.drag-inner-list {
    min-height: 50px;
    color: white;
}

.drag-item {
    padding: 10px;
    margin: 10px;
    background: rgba(rgb(255, 254, 254), 0.4);
    color: rgb(49, 49, 49);
    transition: $ease-out;
    position: relative;
    border: solid 1px rgba(rgb(211, 209, 209), 0.8);
    border-left: solid 4px red;
    &.is-moving {
        font-family: Roboto,sans-serif;
        color: rgb(49, 49, 49);
        transform: scale(1.5);
        background: rgba(rgb(102, 101, 101), 0.4);
    }
    .date {
      font-size: 12px;
      color: grey;
    }
    .comment {
      font-size: 12px;
      color: grey;
    }

  .controls {
    position: absolute;
    top: 10px;
    right: 10px;

    .controls-holder {
      display: flex;
      justify-content: flex-end;
      .item {
        cursor: pointer;
      }
    }
  }
}

.in-progress {
  .drag-item {
    border-left: solid 4px grey;
  }
}
.needs-review {
  .drag-item {
    border-left: solid 4px blue;
  }
}
.done {
  .drag-item {
    border-left: solid 4px green;
  }
}

.drag-header-more {
    cursor: pointer;
}

.drag-options {
    position: absolute;
    top: 44px;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 10px;
    transform: translateX(100%);
    opacity: 0;
    transition: $ease-out;

    &.active {
        transform: translateX(0);
        opacity: 1;
    }

    &-label {
        display: block;
        margin: 0 0 5px 0;

        input {
            opacity: 0.6;
        }

        span {
            display: inline-block;
            font-size: 0.9rem;
            font-weight: 400;
            margin-left: 5px;
        }
    }
}

/* Dragula CSS  */

.gu-mirror {
  position: fixed !important;
  margin: 0 !important;
  z-index: 9999 !important;
  opacity: 0.8;
    list-style-type: none;
}

.gu-hide {
  display: none !important;
}

.gu-unselectable {
  -webkit-user-select: none !important;
  -moz-user-select: none !important;
  -ms-user-select: none !important;
  user-select: none !important;
}

.gu-transit {
  opacity: 0.2;
}

</style>
